var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { RoutePath, StakingTab, generateRoutePath } from '../../app/router/config';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { WalletConnectionType } from '../../types/blockchain';
import { DialogType } from '../../types/dialogs';
import { checkIfWalletAsEnoughCurrency, formatCtaTokenPrice } from '../../utils/balances';
import { formatDate } from '../../utils/date';
import { useCtaTokenRates } from './use-cta-token-rates';
import { CTA_TOKEN_STAKE_MINT_PASS_USD_PRICE, CTA_TOKEN_STAKE_NO_MINT_PASS_USD_PRICE, } from './use-my-stakings';
export function useStakingCreate() {
    var _a = useI18n(), t = _a.t, i18n = _a.i18n;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _b = useContext(UserContext), user = _b.user, systemInfo = _b.systemInfo, balances = _b.balances, localWalletAddress = _b.localWalletAddress, reconnectUser = _b.reconnectUser;
    var _c = useContext(CurrencyContext), imxClient = _c.imxClient, parseCurrencyQuantity = _c.parseCurrencyQuantity;
    var _d = useCtaTokenRates(), ctaTokenUsdRate7d = _d.ctaTokenUsdRate7d, secondsBeforeRefetch = _d.secondsBeforeRefetch, timestamp = _d.timestamp;
    var _e = useState(undefined), mintPasses = _e[0], setMintPasses = _e[1];
    var _f = useState(undefined), selectedMintPass = _f[0], setSelectedMintPass = _f[1];
    var _g = useState(1), weekCountDuration = _g[0], setWeekCountDuration = _g[1];
    var _h = useState(1), countToCreate = _h[0], setCountToCreate = _h[1];
    var _j = useState(3000), ctaTokenPrice = _j[0], setCtaTokenPrice = _j[1];
    var _k = useState(false), acceptTerms = _k[0], setAcceptTerms = _k[1];
    var _l = useState(undefined), recap = _l[0], setRecap = _l[1];
    var _m = useState(false), notEnoughCurrency = _m[0], setNotEnoughCurrency = _m[1];
    useEffect(function () {
        function getUserPerks() {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress))
                                return [2 /*return*/];
                            return [4 /*yield*/, gqlSdk.UserGetPerks()];
                        case 1:
                            result = _a.sent();
                            setMintPasses(result.userGetPerks.mintPasses);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getUserPerks();
    }, [user]);
    useEffect(function () {
        function getRecap() {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setRecap(undefined);
                            return [4 /*yield*/, gqlSdk.CtaTokenStakeCreatePreview({
                                    input: {
                                        countToCreate: countToCreate,
                                        weekCountDuration: weekCountDuration,
                                        mintPassUuid: selectedMintPass === null || selectedMintPass === void 0 ? void 0 : selectedMintPass.uuid,
                                        ctaTokenUsdValueTimestamp: timestamp,
                                    },
                                })];
                        case 1:
                            result = _a.sent();
                            setRecap(result.ctaTokenStakeCreatePreview);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getRecap();
    }, [selectedMintPass, weekCountDuration, countToCreate, timestamp]);
    useEffect(function () {
        if (ctaTokenUsdRate7d === 0)
            return;
        var ctaTokenAmount = selectedMintPass
            ? Math.min(Math.round(CTA_TOKEN_STAKE_MINT_PASS_USD_PRICE / ctaTokenUsdRate7d), 1500)
            : Math.round(CTA_TOKEN_STAKE_NO_MINT_PASS_USD_PRICE / ctaTokenUsdRate7d);
        setCtaTokenPrice(ctaTokenAmount * countToCreate);
    }, [countToCreate, selectedMintPass, ctaTokenUsdRate7d]);
    useEffect(function () {
        setCountToCreate(1);
    }, [selectedMintPass]);
    useEffect(function () {
        if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress))
            return;
        var hasEnoughCurrency = checkIfWalletAsEnoughCurrency(user, balances, { address: user.mpcWalletAddress, connectionType: WalletConnectionType.MPC }, localWalletAddress, parseCurrencyQuantity, appEnv.ctaTokenAddress, formatCtaTokenPrice(ctaTokenPrice));
        setNotEnoughCurrency(!hasEnoughCurrency);
    }, [ctaTokenPrice, balances, localWalletAddress]);
    function stakeTokens() {
        return __awaiter(this, void 0, void 0, function () {
            var error, orders, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setServerLoading(true);
                        error = '';
                        if (!selectedMintPass) return [3 /*break*/, 2];
                        return [4 /*yield*/, imxClient.listOrders({
                                sellTokenId: selectedMintPass.tokenId.toString(),
                                sellTokenAddress: appEnv.blockchain.collectionAddress,
                                status: 'active',
                            })];
                    case 1:
                        orders = _b.sent();
                        if (orders.result.length > 0) {
                            error = t('error.mint-pass-listed-for-sale');
                        }
                        _b.label = 2;
                    case 2:
                        if (!(error.length === 0)) return [3 /*break*/, 6];
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, gqlSdk.CtaTokenStakeCreate({
                                input: {
                                    mintPassUuid: selectedMintPass === null || selectedMintPass === void 0 ? void 0 : selectedMintPass.uuid,
                                    weekCountDuration: weekCountDuration,
                                    countToCreate: countToCreate,
                                    ctaTokenUsdValueTimestamp: timestamp,
                                },
                            })];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _a = _b.sent();
                        error = t('error.generic');
                        return [3 /*break*/, 6];
                    case 6:
                        if (!(error.length === 0)) return [3 /*break*/, 8];
                        return [4 /*yield*/, reconnectUser()];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8:
                        setDialogProps({
                            common: {
                                title: error.length > 0 ? t('common.error') : t('common.success'),
                                close: error.length > 0 ? { text: t('common.back'), action: function () { return setDialogProps(undefined); } } : undefined,
                                actions: error.length > 0
                                    ? []
                                    : [{ text: t('common.back'), link: generateRoutePath(RoutePath.STAKING, { tab: StakingTab.MY_STAKINGS }) }],
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error.length > 0 ? error : t('staking.create.success-message'),
                            },
                        });
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showRecapDialog() {
        if (!recap)
            return;
        setDialogProps({
            common: {
                title: t('staking.create-staking.confirm-staking'),
                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                actions: [{ text: t('staking.stake-tokens'), action: stakeTokens }],
            },
            custom: {
                type: DialogType.STAKING_RECAP,
                countToCreate: countToCreate,
                ctaTokenPrice: ctaTokenPrice,
                ctaTokenUsdRate: ctaTokenUsdRate7d,
                lastAirdropDate: formatDate(moment(systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.weeklyMissionReset).add(weekCountDuration, 'week').toString(), i18n.language),
                selectedMintPass: selectedMintPass,
                vipPointsToCome: recap.loyaltyPointsIncrease,
            },
        });
    }
    return {
        mintPasses: mintPasses,
        selectedMintPass: selectedMintPass,
        setSelectedMintPass: setSelectedMintPass,
        weekCountDuration: weekCountDuration,
        setWeekCountDuration: setWeekCountDuration,
        countToCreate: countToCreate,
        setCountToCreate: setCountToCreate,
        ctaTokenPrice: ctaTokenPrice,
        acceptTerms: acceptTerms,
        setAcceptTerms: setAcceptTerms,
        recap: recap,
        stakeTokens: stakeTokens,
        ctaTokenUsdRate7d: ctaTokenUsdRate7d,
        secondsBeforeRefetch: secondsBeforeRefetch,
        showRecapDialog: showRecapDialog,
        notEnoughCurrency: notEnoughCurrency,
    };
}
